<template>
  <v-row>
    <v-col cols="12">
      <v-select
        :items="campaigns"
        v-model="selectedCampaign"
        item-text="name"
        item-value="id"
        label="Select Campaign"
        single-line
        outline
        class="select-bordered"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'audience-report-item-selector',
    data () {
      return {
        selectedCampaign: null
      }
    },
    props: {
      campaigns: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      selectedCampaign (val) {
        this.$emit('selectCampaign', val)
      }
    }
  }
</script>
